// src/components/IframeHeightReporter.js
// Posts the document's scroll height to the parent window so a Wix-embedded
// iframe can auto-resize to fit content (no double scrollbars or cut-off footer).
//
// To listen on the Wix side, add this snippet to your Wix HTML embed widget:
//   <script>
//     window.addEventListener('message', (e) => {
//       if (e.data && e.data.type === 'njjba-iframe-height') {
//         const iframe = document.querySelector('iframe[src*="portal.njjba.com/embed"]');
//         if (iframe) iframe.style.height = e.data.height + 'px';
//       }
//     });
//   </script>

import { useEffect } from 'react';

export default function IframeHeightReporter() {
  useEffect(() => {
    const send = () => {
      const height = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      try {
        window.parent.postMessage({ type: 'njjba-iframe-height', height }, '*');
      } catch (_) { /* swallow */ }
    };

    // Initial + on-resize updates
    send();
    window.addEventListener('resize', send);

    // ResizeObserver catches content changes (images loading, modals opening, etc.)
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(send);
      ro.observe(document.body);
    }

    // Fallback: poll every 800ms in case ResizeObserver misses something (e.g. fonts loading late)
    const interval = setInterval(send, 800);

    return () => {
      window.removeEventListener('resize', send);
      if (ro) ro.disconnect();
      clearInterval(interval);
    };
  }, []);

  return null;
}
